import PropTypes from "prop-types";
import Thumb from "./Thumb";

/* Read-only list of what is coming back to us. */
const ReturnedItems = ({ lines, formatPrice }) => (
  <section className="c4rtn__card" aria-labelledby="c4rtn-returned-heading">
    <h2 className="c4rtn__card-title" id="c4rtn-returned-heading">
      Items Being Returned ({lines.length})
    </h2>

    <ul className="c4rtn__items c4rtn__items--plain">
      {lines.map((line) => (
        <li className="c4rtn__item" key={line.id}>
          <div className="c4rtn__item-main">
            <Thumb image={line.image} name={line.name} />

            <span className="c4rtn__item-info">
              <span className="c4rtn__item-name">{line.name}</span>
              <span className="c4rtn__item-meta">Qty {line.quantity}</span>
            </span>
          </div>

          <span className="c4rtn__item-price">
            {line.lineTotal != null ? formatPrice(line.lineTotal) : "—"}
          </span>
        </li>
      ))}
    </ul>
  </section>
);

ReturnedItems.propTypes = {
  lines: PropTypes.array.isRequired,
  formatPrice: PropTypes.func.isRequired,
};

export default ReturnedItems;
